"use client";

import dynamic from "next/dynamic";

// Lazy load non-critical components with ssr: false
const Footer = dynamic(() => import("@/components/home/Footer"), { ssr: false });
const WhatsAppBtn = dynamic(() => import("@/components/ui/WhatsAppBtn"), {
  ssr: false,
});

export function ClientFooter() {
  return <Footer />;
}

export function ClientWhatsAppBtn() {
  return <WhatsAppBtn />;
}
